import { SelectOption } from '@doveit/bricks';
import { InvoiceType, Status } from '../../../domain/types';
import { invoiceTypeLabels } from '../../../labels';
import { DEFAULT_EMPTY_SELECT_OPTION } from '../../../select-options/utils/asSelectOptions';

export function getTypeFieldOptions(propertyStatus?: Status, isCollected?: boolean): SelectOption[] {
  const options = [InvoiceType.EXTRA_PACKAGE, InvoiceType.CREDIT_NOTE, InvoiceType.PENALTY];

  if (propertyStatus === Status.VENDUTO && !isCollected) {
    options.push(InvoiceType.MEDIATION);
  }

  const normalizedOptions = options.map((type) => ({
    value: type,
    label: invoiceTypeLabels[type],
  }));

  return [{ ...DEFAULT_EMPTY_SELECT_OPTION, disabled: true }, ...normalizedOptions];
}
